/**
 * Si el mercado (/mercado) y los distribuidores (/distribuidores), y sus
 * versiones en inglés, están a la vista. Apagados dan 404, no salen en menús
 * ni en los mapas del sitio. El seguimiento de un pedido ya hecho
 * (/mercado/pedido/<token>) sigue funcionando, y el panel de los vendedores
 * no depende de esto.
 */
export const MERCADO_PUBLICO = true
